import { useMemo } from 'react'
import useOffer from 'hooks/Offers/useOffer'
import { getPackageUniqueKey } from 'lib/offer/offerUtils'
import type { CartPanelAccommodationItem } from './useCartPanelItems'

export type CartPanelHotelOffer = App.HotelOffer | App.BedbankOffer

function isBedbankOffer(offer: CartPanelHotelOffer): offer is App.BedbankOffer {
  return offer.type === 'bedbank_hotel'
}

function useCartPanelHotelOfferData(item: CartPanelAccommodationItem) {
  const [offer, loading] = useOffer<CartPanelHotelOffer>(item.offerId)

  const cartHotelItem = item.cartItem as App.MultiCartInstantBookingLEHotelItem | undefined

  const pkg = useMemo(() => {
    if (!offer) return undefined

    if (isBedbankOffer(offer)) {
      return offer.packages.find(p => p.roomId === item.packageId)
    }

    if (!cartHotelItem?.packageId || !cartHotelItem?.roomRateId) return undefined
    const duration = item.duration ?? cartHotelItem.duration
    const uniqueKey = getPackageUniqueKey(cartHotelItem.packageId, duration, cartHotelItem.roomRateId)
    return offer.packages.find(p => p.uniqueKey === uniqueKey)
  }, [offer, cartHotelItem, item.duration, item.packageId])

  return {
    offer,
    pkg,
    loading,
    checkIn: cartHotelItem?.checkIn,
    checkOut: cartHotelItem?.checkOut,
  }
}

export default useCartPanelHotelOfferData
